import { render, staticRenderFns } from "./UserConfirmation.vue?vue&type=template&id=3d53bfbe&scoped=true"
import script from "./UserConfirmation.vue?vue&type=script&lang=js"
export * from "./UserConfirmation.vue?vue&type=script&lang=js"
import style0 from "./UserConfirmation.vue?vue&type=style&index=0&id=3d53bfbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d53bfbe",
  null
  
)

export default component.exports